import React from 'react';
import i18next from "../../i18n";
export function AccessDeniedPage(props) {
	return (
		<div className="content" >
			<h1>{i18next.t("accessDeniedMessage")}</h1>
		</div>
	);
}